import {Component, Input} from '@angular/core';
import {EditModalSectionBaseComponent} from '../edit-modal-section-base.component';
import {EditModalService} from '../../../services/edit-modal.service';
import {OfferTextModuleTypeEnum} from '../../../enums/offer-text-module-type.enum';
import {MyOfferTextModuleContainerModel} from '../../../models/my-offer-text-module-container.model';
import {OfferTextModulesContainersUtilsService} from '../../../services/offer-text-modules-containers-utils.service';

@Component({
    selector: 'app-offer-text-modules-editor',
    templateUrl: './offer-text-modules-editor.component.html',
    styleUrls: ['./offer-text-modules-editor.component.scss']
})
export class OfferTextModulesEditorComponent  extends EditModalSectionBaseComponent  {

    @Input() previewMode = false;

    constructor(
        public  editModalService: EditModalService,
        private offerTextModulesContainersUtilsService: OfferTextModulesContainersUtilsService
    ) {
        super(editModalService);
    }


    public getModuleTitle(textModuleType: string): string {
        return  OfferTextModuleTypeEnum[textModuleType];
    }

    onCheckBoxClicked(offerTextModuleContainer: MyOfferTextModuleContainerModel) {
        if( !offerTextModuleContainer.isChecked) {
            offerTextModuleContainer.offerTextModule.text = this.offerTextModulesContainersUtilsService.getDefaultModuleText(
                OfferTextModuleTypeEnum[offerTextModuleContainer.offerTextModule.textModuleType]
            )
        }
    }
}
